/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { RowsContext } from '../contexts';

export const useRowsStore = () => useContext(RowsContext);
